import { get, post, patch, deleteRequest } from "./api";

export const fetchTreatmentProjections = (customerId) =>
  get(
    `/api/v2/customer-treatment-projections/?customer=${customerId}`
  );

export const createTreatmentProjection = (payload) =>
  post(
    `/api/v2/customer-treatment-projections/`,
    payload
  );

export const updateTreatmentProjection = (id, payload) =>
  patch(
    `/api/v2/customer-treatment-projections/${id}/`,
    payload
  );

export const deleteTreatmentProjection = (id) =>
  deleteRequest(
    `/api/v2/customer-treatment-projections/${id}/`
  );

export const getCustomTargetPerformanceData = (id, signal, date) =>
     get(
    `/api/v2/customer/${id}/getcustomtargetperformance/${date}/`, {}, false, signal
  );

export function getCustomerMonthlyTargets(customerId, endDate) {
  return get(`/api/v2/customer/${customerId}/targets/${endDate}/`);
}

export function getTargetCycle(customer_id, date) {
  return get(`/api/v2/customer/${customer_id}/target-cycle/${date}/`);
}

export function updateTargetCycle(customer_id, date, payload) {
  return post(`/api/v2/customer/${customer_id}/target-cycle/${date}/`, payload);
}


export function saveCustomMonthlyTarget(customer_id, year, month, payload) {
  return post(
    `/api/v2/customer/${customer_id}/monthly-target/${year}/${month}/`,
    payload
  );
}

export function generateTargets(customer_id, dashboard_date) {
  return post(
    `/api/v2/customer/${customer_id}/customtargetgenerator/${dashboard_date}/`
  );
}

export const updateTargetsBulk = (params) => {
  return post(
    "/api/v2/customers/targets/generate/bulk/",
    params,
  );
};

export const getTargetValues = ({ customerId, endDate }) => {
  return get(
    `/api/v2/customers/${customerId}/targetvalue/${endDate}/`
  );
};

export const updateTargetValue = ({ customerId, endDate, indicatorId, targetValue }) => {
  return post(
    `/api/v2/customers/${customerId}/targetvalue/${endDate}/`,
    {
      indicator_id: indicatorId,
      target_value: targetValue,
    }
  );
};